import React, { Component } from "react"
import Icon from "react-icons-kit"
import { Segment } from "semantic-ui-react"
import "./BandeauNoir.css"

class BandeauNoir extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <Segment id="backBandeauNoir">
        <h2 id="nameCategorie">
          {this.props.icon ? (
            <Icon size={28} id="iconnavbar" icon={this.props.icon} />
          ) : (null)}
          {this.props.category}
        </h2>{" "}
        {this.props.children}
      </Segment>
    )
  }
}

export default BandeauNoir



// WEBPACK FOOTER //
// ./src/components/Pro/Entete/BandeauNoir.js